import * as api from "../api";
import toast from "react-hot-toast";
import { DateFormatter2 } from "../../helpers/DateFormatter2";

export const GET_TRANSACTIONS_SUCCESS = "GET_TRANSACTIONS_SUCCESS";
export const CLEAR_TRANSACTIONS = "CLEAR_TRANSACTIONS";

export const getTransactionByDate =
  (date, today = false) =>
  async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      let response;
      if (today) {
        response = await api.apiGetTransactionToday(accessToken);
      } else {
        response = await api.apiGetTransactionByDate(accessToken, date);
      }
      let dataArray = [];
      response.data.forEach((item) => {
        const formattedDate = DateFormatter2(item.createdDate);
        const tempArray = [
          item.id,
          item.customerId,
          item.customerName,
          item.amount,
          item.transactionType,
          item.collectorName,
          item.transactionStatus,
          formattedDate,
        ];
        dataArray = [...dataArray, tempArray];
      });
      dispatch({ type: GET_TRANSACTIONS_SUCCESS, payload: dataArray });
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
    }
  };

export const clearTransactionsData = () => {
  return { type: CLEAR_TRANSACTIONS };
};
